module.exports = __webpack_public_path__ + "static/media/sfotokapak.db0ffdf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sfotokapak.png
// module id = 374
// module chunks = 0